var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hinava_random_uuid_64564739423600281813317842033028324445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3214 11.215H15.7321V9.44714C15.7321 7.38955 14.0576 5.715 12 5.715C9.94241 5.715 8.26786 7.38955 8.26786 9.44714V11.215H7.67857C7.0279 11.215 6.5 11.7429 6.5 12.3936V17.1079C6.5 17.7585 7.0279 18.2864 7.67857 18.2864H16.3214C16.9721 18.2864 17.5 17.7585 17.5 17.1079V12.3936C17.5 11.7429 16.9721 11.215 16.3214 11.215ZM13.7679 11.215H10.2321V9.44714C10.2321 8.47236 11.0252 7.67928 12 7.67928C12.9748 7.67928 13.7679 8.47236 13.7679 9.44714V11.215Z",
    fill: "url(#hinava_random_uuid_262507779585634454606962713004083890851)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3214 11.215H15.7321V9.44714C15.7321 7.38955 14.0576 5.715 12 5.715C9.94241 5.715 8.26786 7.38955 8.26786 9.44714V11.215H7.67857C7.0279 11.215 6.5 11.7429 6.5 12.3936V17.1079C6.5 17.7585 7.0279 18.2864 7.67857 18.2864H16.3214C16.9721 18.2864 17.5 17.7585 17.5 17.1079V12.3936C17.5 11.7429 16.9721 11.215 16.3214 11.215ZM13.7679 11.215H10.2321V9.44714C10.2321 8.47236 11.0252 7.67928 12 7.67928C12.9748 7.67928 13.7679 8.47236 13.7679 9.44714V11.215Z",
    fill: "#008C60",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hinava_random_uuid_64564739423600281813317842033028324445",
    x: 6.5,
    y: 5.715,
    width: 11,
    height: 12.5714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4080_8207"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_262507779585634454606962713004083890851",
    x1: 12,
    y1: 5.715,
    x2: 12,
    y2: 18.2864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOn);
export default __webpack_public_path__ + "static/media/lock-on.60eea9839d271207b6f3a78aee2d70ba.svg";
export { ForwardRef as ReactComponent };